/**
 * kW の Decimal 文字列 (編集・送信用)。 number にすると桁が丸まる / 1e-7 のような指数表記になるため、
 * 画面は元の文字列を持ち回り、 number は表示 (`formatKwDecimal`) と大小比較にだけ使う。
 */

/** 数として読める文字列か (空や英字混じりは false)。 */
export const isNumericKw = (kw: string): boolean =>
  kw.trim() !== '' && Number.isFinite(Number(kw))

/** 大小比較 (並べ替え用)。 数として読めない値は 0 扱い。 */
export const compareKw = (a: string, b: string): number =>
  (Number(a) || 0) - (Number(b) || 0)
